import { render, staticRenderFns } from "./ExercicioFiscalForm.vue?vue&type=template&id=adddd90c"
import script from "./ExercicioFiscalForm.vue?vue&type=script&lang=js"
export * from "./ExercicioFiscalForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports